var merge = require('lodash/merge')

const mutations = {
  SET_APPLICATION(state, application) {
    state.application = application
  },
  SET_APPLICATION_COMPANY(state, company) {
    state.company = company
  },
  SET_APPLICATION_PROFESSION(state, profession) {
    state.profession = profession
  },
  SET_APPLICATION_EMPLOYEE(state, employee) {
    state.employee = employee
  },
  SET_APPLICATION_COMPANY_EMPLOYMENTS(state, companyEmployments) {
    state.companyEmployments = companyEmployments
  },
  SET_APPLICATION_ORDERS(state, orders) {
    state.orders = orders
  },
  SET_APPLICATION_DISTANCE_EDUCATIONS(state, distanceEducations) {
    state.distanceEducations = distanceEducations
  },
  SET_APPLICATION_WORKPLACE(state, workplace) {
    state.workplace = workplace
  },
  SET_APPLICATION_DEPARTMENTS(state, departments) {
    state.departments = departments
  },
  SET_APPLICATION_DEPARTMENT(state, department) {
    state.department = department
  },
  UPDATE_APPLICATION(state, application) {
    const mergedData = merge(JSON.parse(JSON.stringify(state.application)), application)
    state.application = mergedData
  }

}
export default mutations
